/* MUTE Back-to-Top + Smooth-Scroll (Phase 5.5.3, 2026-06-01)
   - Button erscheint ab 1000px Scroll, scrollt nach oben.
   - Smooth-Scroll global via scroll-behavior (reduced-motion respektiert).
   - A11y: button mit aria-label, 44px Touch-Target, Focus-Ring.
   - Selbst-initialisierend, kein Dawn-Vendor-Edit. */
(function () {
  'use strict';
  if (window.__muteBackToTop) return;
  window.__muteBackToTop = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SHOW_AT = 1000;

  function injectStyle() {
    if (document.getElementById('mute-btt-style')) return;
    var css =
      'html{scroll-behavior:' + (reduce ? 'auto' : 'smooth') + ';}' +
      '#mute-btt{position:fixed;right:clamp(12px,3vw,24px);bottom:clamp(12px,3vw,24px);' +
      'z-index:2147482000;width:44px;height:44px;display:flex;align-items:center;justify-content:center;' +
      'cursor:pointer;border:1px solid var(--mute-text-primary,#0A0A0A);' +
      'background:var(--mute-bg-white,#FFFFFF);color:var(--mute-text-primary,#0A0A0A);' +
      'box-shadow:0 4px 16px rgba(0,0,0,.14);opacity:0;visibility:hidden;' +
      'transform:translateY(8px);transition:opacity 160ms ease,transform 160ms ease,visibility 160ms ease,background 120ms ease;}' +
      '#mute-btt.is-visible{opacity:1;visibility:visible;transform:translateY(0);}' +
      '#mute-btt:hover{background:var(--mute-text-primary,#0A0A0A);color:var(--mute-bg-white,#FFFFFF);}' +
      '#mute-btt:focus-visible{outline:3px solid var(--mute-signal-red,#FF4D2E);outline-offset:2px;}' +
      '#mute-btt svg{width:20px;height:20px;display:block;}' +
      '@media (prefers-reduced-motion: reduce){#mute-btt{transition:opacity 120ms ease,visibility 120ms ease;transform:none;}#mute-btt.is-visible{transform:none;}}';
    var st = document.createElement('style');
    st.id = 'mute-btt-style';
    st.textContent = css;
    document.head.appendChild(st);
  }

  function build() {
    injectStyle();
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'mute-btt';
    btn.setAttribute('aria-label', 'Nach oben');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    (document.body || document.documentElement).appendChild(btn);

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;
        btn.classList.toggle('is-visible', y > SHOW_AT);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (document.body) build();
  else document.addEventListener('DOMContentLoaded', build);
})();
